import { Fragment, useEffect, useRef } from "react";
import Toasting from "../components/Toasting";

export type PromiseViewProps = {
  promise: Promise<unknown> | null;
  message?: string | null;
};

export default function PromiseToast(props: PromiseViewProps) {
  const { promise, message } = props;

  const ref = useRef<Promise<unknown> | null>(promise);
  ref.current = promise;

  useEffect(() => {
    if (promise === null) return;
    promise.then(
      () => {
        if (ref.current !== promise) return;
        if (message === null) return;
        const text = message || "C'est fait !";
        Toasting.success(text);
      },
      (err) => {
        if (ref.current !== promise) return;
        Toasting.fromError(err);
      },
    );
  }, [promise, message]);

  return <Fragment />;
}
